import { createContext, useCallback, useEffect, useState } from "react";
import apiClient from "../utils/ApiClient/apiClientAxios";
import { checkAndUpdateCache } from "../utils/cacheVersionCheck";
export const AuthContext = createContext();

// eslint-disable-next-line react/prop-types
export const AuthProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [userData, setUserData] = useState(null);

  const handleLogin = useCallback((redirectTo) => {
    if (redirectTo) localStorage.setItem("postLoginRedirect", redirectTo);
    window.location.href = "/.auth/login/aad";
  }, []);

  const handleLogOut = useCallback(() => {
    const authUser = JSON.parse(
      localStorage.getItem("AuthenticatedUser") || "{}",
    );
    const userId = authUser?.userId;
    if (userId) {
      localStorage.removeItem(`disclaimer_ack_${userId}_currentLogin`);
    }
    localStorage.removeItem("AuthenticatedUser");
    localStorage.removeItem("postLoginRedirect");

    setTimeout(() => {
      window.location.href = "/.auth/logout/complete";
    }, 500);
  }, []);

  useEffect(() => {
    let mounted = true;
    const loadUser = async () => {
      setIsLoading(true);
      try {
        const authRes = await fetch("/.auth/me");
        const authData = await authRes.json();

        if (!authData?.clientPrincipal) {
          setUserData(null);
          setIsLoading(false);
          return;
        }
        // ✅ If authenticated, then safely fetch user details
        const res = await apiClient.get("/getuser");
        if (!mounted) return;
        setUserData(res.data);
        localStorage.setItem("AuthenticatedUser", JSON.stringify(res.data));
        await checkAndUpdateCache();
        setIsLoading(false);
      } catch (err) {
        setUserData(null);
        setIsLoading(false);
      }
    };

    loadUser();
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    if (!isLoading && userData) {
      const redirect = localStorage.getItem("postLoginRedirect");
      if (redirect && redirect !== window.location.pathname) {
        localStorage.removeItem("postLoginRedirect");
        window.location.href = redirect;
      }
    }
  }, [isLoading, userData]);

  const isAuthenticated = Boolean(
    userData?.userRoles?.includes("authenticated"),
  );
  const isDedupAvailable = Boolean(
    userData?.userRoles?.includes("persondedup"),
  );
  const isAdmin = Boolean(userData?.userRoles?.includes("admin"));
  const isSuperUser = Boolean(userData?.userRoles?.includes("superuser"));
  const isImportUser = Boolean(userData?.userRoles?.includes("import"));

  return (
    <AuthContext.Provider
      value={{
        isLoading,
        userData,
        handleLogin,
        handleLogOut,
        isAuthenticated,
        isDedupAvailable,
        isAdmin,
        isSuperUser,
        isImportUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
